import Component from '@glimmer/component';
import { computed } from '@ember/object';
import ChatApi from 'mewe/api/chat-api';

export default class ChatMessageEmojis extends Component {
  chatApi = ChatApi;
}
